/* Shoppable blog kit — positions the Answer Card, manages the sticky bar, hides the default carousel, tracks clicks. */
(function () {
  'use strict';
  var content = document.querySelector('.article-template__content');
  if (!content) return;

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  /* 1. Answer Card placement: end of the section whose heading matches data-anchor. */
  var card = document.querySelector('[data-bns-card]');
  if (card) {
    var anchor = norm(card.getAttribute('data-anchor'));
    /* Headings = h2/h3, plus paragraphs that are entirely bold (Proov posts use <p><b>1. Low progesterone</b></p> as sub-headings). */
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3, p')).filter(function (el) {
      if (/^H[23]$/.test(el.tagName)) return true;
      var t = norm(el.textContent); if (!t || t.length > 80) return false;
      var b = el.querySelector('b, strong'); return !!b && norm(b.textContent) === t;
    });
    function isHeading(el) { return headings.indexOf(el) !== -1; }
    var target = null;
    if (anchor) {
      for (var i = 0; i < headings.length; i++) {
        if (norm(headings[i].textContent).indexOf(anchor) !== -1) { target = headings[i]; break; }
      }
    }
    if (target) {
      var node = target.nextElementSibling;
      while (node && !isHeading(node)) node = node.nextElementSibling;
      if (node) node.parentNode.insertBefore(card, node); else content.appendChild(card);
    } else {
      var paras = content.querySelectorAll('p');
      var after = paras[3] || paras[paras.length - 1];
      if (after && after.parentNode) after.parentNode.insertBefore(card, after.nextSibling); else content.appendChild(card);
      if (window.console) console.warn('[blog-next-step] anchor not found for', card.getAttribute('data-article'), '→ fallback placement');
    }
    card.hidden = false;
  }

  /* 1b. Reading frame: move under the title (before the hero image), hide the duplicate title graphic, build the jump list. */
  var qa = document.querySelector('[data-bns-qa]');
  if (qa) {
    var hero = document.querySelector('.article-template__img');
    var header = document.querySelector('.article-template__header');
    if (hero && hero.parentNode) { hero.parentNode.insertBefore(qa, hero); hero.hidden = true; }
    else if (header) { header.appendChild(qa); }
    /* Hide the italic "Written by" line in the body only when the strip already carries a byline. */
    var first = content.querySelector('p');
    if (qa.hasAttribute('data-has-byline') && first && /^written by/i.test(norm(first.textContent))) first.hidden = true;
    /* Jump list from H2s (H3s if the post has no H2s). */
    var toc = qa.querySelector('[data-bns-toc]');
    var list = toc && toc.querySelector('.bns-toc__list');
    var hs = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (hs.length < 2) hs = Array.prototype.slice.call(content.querySelectorAll('h3'));
    hs = hs.filter(function (h) { return norm(h.textContent).length > 2; });
    if (list && hs.length >= 2) {
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); list.appendChild(li);
      });
      toc.hidden = false;
    }
    qa.hidden = false;
  }

  /* 1c. Body images: hide legacy in-body product banners (an <a> to a product wrapping only an image) once a card exists,
         and make the remaining article images responsive + lazy via Shopify CDN width params. */
  if (card) {
    content.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('[data-bns-card]')) return;
      var kids = Array.prototype.filter.call(a.childNodes, function (n) { return !(n.nodeType === 3 && !n.textContent.trim()); });
      var onlyImg = kids.length === 1 && (kids[0].tagName === 'IMG' || (kids[0].querySelector && kids[0].querySelector('img') && !kids[0].textContent.trim()));
      if (onlyImg) { var wrap = a.closest('p, div') || a; wrap.hidden = true; }
    });
  }
  content.querySelectorAll('img').forEach(function (img, i) {
    var src = img.getAttribute('src') || '';
    if (i > 0) { img.loading = 'lazy'; img.decoding = 'async'; }
    if (/cdn\.shopify\.com\/s\/files\//.test(src) && !img.getAttribute('srcset')) {
      var base = src.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      var join = base.indexOf('?') === -1 ? '?' : '&';
      img.setAttribute('srcset', [480, 720, 1080].map(function (w) { return base + join + 'width=' + w + ' ' + w + 'w'; }).join(', '));
      img.setAttribute('sizes', '(max-width: 749px) 100vw, 720px');
    }
    if (img.style && img.style.float === 'none') img.style.margin = '';
  });

  /* 2. Hide the theme's default popular-products carousel when matched products or support mode are present. */
  if (document.querySelector('[data-bns-matched], [data-bns-support]')) {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.id && s.id.indexOf('popular_products') !== -1) s.hidden = true;
    });
  }

  /* 3. Sticky bar: mobile only, after 25% scroll, hidden when footer is in view. */
  var sticky = document.querySelector('[data-bns-sticky]');
  if (sticky) {
    var mq = window.matchMedia('(max-width: 749px)');
    var footer = document.querySelector('footer, .footer, #shopify-section-footer');
    var footerVisible = false;
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    }
    function update() {
      if (!mq.matches) { sticky.hidden = true; sticky.classList.remove('is-fixed'); return; }
      var doc = document.documentElement;
      var progress = (window.scrollY || doc.scrollTop) / Math.max(1, doc.scrollHeight - window.innerHeight);
      var show = progress > 0.25 && !footerVisible;
      sticky.classList.add('is-fixed');
      sticky.hidden = !show;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 4. Click tracking → dataLayer (GTM forwards to Ours Privacy / GA4). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-placement]');
    if (!a) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'blog_cta_click',
      article: (card && card.getAttribute('data-article')) || location.pathname.split('/').pop(),
      placement: a.getAttribute('data-placement'),
      product: a.getAttribute('data-product') || (card && card.getAttribute('data-product')) || ''
    });
  });
})();
